import * as types from "./types"

const initialState = {
    periodeRpjmd: {
        loading: false,
        error: false,
        message: "",
        data: [],
        lastUpdated: "",
        author: ""
    },
    ikuRpjmd: {
        loading: false,
        error: false,
        message: "",
        data: [],
        lastUpdated: "",
        author: ""
    },
    listOpdIkd: {
        loading: false,
        error: false,
        message: "",
        data: [],
        lastUpdated: "",
        author: ""
    },
    dataIkd: {
        loading: false,
        error: false,
        message: "",
        data: [],
        lastUpdated: "",
        author: ""
    },
    dataIup: {
        loading: false,
        error: false,
        message: "",
        data: [],
        lastUpdated: "",
        author: ""
    }
}

export default function newSakatoplanReducer(state = initialState, actions){
    switch(actions.type){
        case types.GET_PERIODERPJMD_NEWSAKATOPLAN_START:
            return {
                ...state,
                periodeRpjmd:{
                    ...state.periodeRpjmd,
                    loading: true,
                    error: false,
                    message: 'waiting'
                }
            }
        case types.GET_PERIODERPJMD_NEWSAKATOPLAN_SUCCESS:
            return {
                ...state,
                periodeRpjmd:{
                    ...state.periodeRpjmd,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-",
                    data: actions.payload.data ?? [], 
                    lastUpdated: actions.payload.timestamp ?? new Date().toLocaleString(),
                    author: actions.payload.author ?? "-"
                }
            }
        case types.GET_PERIODERPJMD_NEWSAKATOPLAN_FAILED:
            return {
                ...state,
                periodeRpjmd:{
                    ...state.periodeRpjmd,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-"
                }
            }


        case types.GET_IKURPJMD_NEWSAKATOPLAN_START:
            return {
                ...state,
                ikuRpjmd:{
                    ...state.ikuRpjmd,
                    loading: true,
                    error: false,
                    message: 'waiting'
                }
            }
        case types.GET_IKURPJMD_NEWSAKATOPLAN_SUCCESS:
            return {
                ...state,
                ikuRpjmd:{
                    ...state.ikuRpjmd,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-",
                    data: actions.payload.data ?? [], 
                    lastUpdated: actions.payload.timestamp ?? new Date().toLocaleString(),
                    author: actions.payload.author ?? "-"
                }
            }
        case types.GET_IKURPJMD_NEWSAKATOPLAN_FAILED:
            return {
                ...state,
                ikuRpjmd:{
                    ...state.ikuRpjmd,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-"
                }
            }


        case types.GET_LISTOPDIKD_NEWSAKATOPLAN_START:
            return {
                ...state,
                listOpdIkd:{
                    ...state.listOpdIkd,
                    loading: true,
                    error: false,
                    message: 'waiting'
                }
            }
        case types.GET_LISTOPDIKD_NEWSAKATOPLAN_SUCCESS:
            return {
                ...state,
                listOpdIkd:{
                    ...state.listOpdIkd,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-",
                    data: actions.payload.data ?? [], 
                    lastUpdated: actions.payload.timestamp ?? new Date().toLocaleString(),
                    author: actions.payload.author ?? "-"
                }
            }
        case types.GET_LISTOPDIKD_NEWSAKATOPLAN_FAILED:
            return {
                ...state,
                listOpdIkd:{
                    ...state.listOpdIkd,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-"
                }
            }
        

        case types.GET_DATAIKD_NEWSAKATOPLAN_START:
            return {
                ...state,
                dataIkd:{
                    ...state.dataIkd,
                    loading: true,
                    error: false,
                    message: 'waiting'
                }
            }
        case types.GET_DATAIKD_NEWSAKATOPLAN_SUCCESS:
            return {
                ...state,
                dataIkd:{
                    ...state.dataIkd,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-",
                    data: actions.payload.data ?? [], 
                    lastUpdated: actions.payload.timestamp ?? new Date().toLocaleString(),
                    author: actions.payload.author ?? "-"
                }
            }
        case types.GET_DATAIKD_NEWSAKATOPLAN_FAILED:
            return {
                ...state,
                dataIkd:{
                    ...state.dataIkd,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-"
                }
            }
        
        case types.GET_DATAIUP_NEWSAKATOPLAN_START:
            return {
                ...state,
                dataIup:{
                    ...state.dataIup,
                    loading: true,
                    error: false,
                    message: 'waiting'
                }
            }
        case types.GET_DATAIUP_NEWSAKATOPLAN_SUCCESS:
            return {
                ...state,
                dataIup:{
                    ...state.dataIup,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-",
                    data: actions.payload.data ?? [], 
                    lastUpdated: actions.payload.timestamp ?? new Date().toLocaleString(),
                    author: actions.payload.author ?? "-"
                }
            }
        case types.GET_DATAIUP_NEWSAKATOPLAN_FAILED:
            return {
                ...state,
                dataIkd:{
                    ...state.dataIup,
                    loading: false,
                    error: false,
                    message: actions.payload.message ?? "-"
                }
            }

        default:
            return state;
    }
}